export default __webpack_public_path__ + "static/media/tom-and-jerry.2c0c88ba.gif";